import { STitle, SUploadedItem } from './UploadedItem.styled'
import { Spinner } from 'components/spinner/Spinner'
import { Text } from 'components/Typography'

export function UploadedItem(props: { title?: string; text?: string; className?: string }) {
  return (
    <SUploadedItem className={props.className}>
      <Spinner />
      <STitle>{props.title || 'Uploading'}</STitle>
      <Text>{props.text}</Text>
    </SUploadedItem>
  )
}
